/* eslint-disable */


/**
 * Create styles for `<LoginPage />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<LoginPage />` styles
 */
const loginPageStyles = ({ isLight, theme }) => ({
  error: {
    color: isLight() ? theme.palette.common.white : theme.palette.common.black,
  },
  loginBox: {
    alignItems: `center`,
    display: `flex`,
    flexDirection: `column`,
    height: `100%`,
    marginTop: theme.spacing(1) * 3,
    overflowY: `auto`,
    [theme.breakpoints.down(`xs`)]: {
      alignItems: `stretch`,
      justifyContent: `stretch`,
    },
  },
  logo: {
    height: 100,
    width: `auto`,
  },
  pageTitle: {
    textAlign: `center`,
  },
  paper: {
    alignItems: `center`,
    background: `inherit`,
    display: `flex`,
    flexDirection: `column`,
    justifyContent: `center`,
    maxWidth: `500px`,
    minHeight: `300px`,
    padding: `${theme.spacing(1) * 3}px ${theme.spacing(1) * 10}px ${theme.spacing(1) * 3}px`,
    width: `50%`,
    [theme.breakpoints.down(`sm`)]: {
      marginTop: theme.spacing(1) * 5,
      padding: `0 ${theme.spacing(1) * 4}px 0`,
      width: `100%`,
    },
  },
  password: {
    color: isLight() ? theme.palette.common.white : theme.palette.common.black,
    marginTop: theme.spacing(1) * 2,
  },
  progress: {
    color: isLight() ? theme.palette.common.white : theme.palette.common.black,
    marginLeft: theme.spacing(1) * 2,
  },
  root: {},
  submitButton: {
    color: isLight() ? theme.palette.common.white : theme.palette.common.black,
    marginTop: theme.spacing(1) * 4,
    maxWidth: `200px`,
    width: `60%`,
  },
});

export default loginPageStyles;
